var _style, _rect, _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMainIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: 0,
    y: 0,
    viewBox: "0 0 500 498.6",
    style: {
      enableBackground: "new 0 0 500 498.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, ".st0{fill:#242424}.st0,.st1{display:none}.st2,.st3{display:inline;fill:#854dff}.st3{fill:#7a4aff}.st4{fill:#fff}.st4,.st5{display:inline}.st6{fill:url(#path26_3_)}.st7{fill:url(#path28_3_)}.st8{fill:url(#path30_3_)}.st9{fill:url(#path32_3_)}.st10{fill:url(#path34_3_)}.st11{fill:url(#path36_3_)}.st12{fill:url(#SVGID_1_)}.st13{fill:url(#path40_3_)}.st14{fill:url(#path42_3_)}.st15{fill:url(#path44_3_)}.st16{fill:url(#path46_3_)}.st17{fill:url(#path48_3_)}.st18{fill:url(#SVGID_2_)}")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 2665.6,
    height: 498.6,
    x: -1082.7,
    className: "st0"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "path26_1_",
    d: "M-691,434.8c0,10.1-8.2,18.3-18.3,18.3h-326.6c-10.1,0-18.3-8.2-18.3-18.3V153.7H-691V434.8z M-696.5,59.4h-46.9v18.8c0,18.3-14.9,33.1-33.1,33.1c-18.3,0-33.1-14.9-33.1-33.1V59.4h-123v18.8c0,19.1-16.3,34.5-35.7,33 c-17.3-1.3-30.6-16-30.6-33.4V59.4h-46.8c-20.1,0-36.3,16.3-36.3,36.3v349.2c0,20,16.3,36.3,36.3,36.3h349.2 c20,0,36.3-16.2,36.3-36.3V95.7C-660.2,75.7-676.4,59.4-696.5,59.4",
    className: "st2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path28_1_",
    d: "M-1016.6,252.7h71.8c2.4,0,4.4-2,4.4-4.4V200c0-2.4-2-4.4-4.4-4.4h-71.8c-2.4,0-4.4,2-4.4,4.4 v48.3C-1020.9,250.8-1019,252.7-1016.6,252.7",
    className: "st2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path30_1_",
    d: "M-908.6,252.7h71.7c2.4,0,4.4-2,4.4-4.4V200c0-2.4-2-4.4-4.4-4.4h-71.7c-2.4,0-4.4,2-4.4,4.4 v48.3C-913,250.8-911,252.7-908.6,252.7",
    className: "st2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path32_1_",
    d: "M-800.4,253.4h71.7c2.4,0,4.4-2,4.4-4.4v-48.3c0-2.4-2-4.4-4.4-4.4h-71.7 c-2.4,0-4.4,2-4.4,4.4V249C-804.7,251.4-802.7,253.4-800.4,253.4",
    className: "st2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path34_1_",
    d: "M-1016.6,332h71.7c2.4,0,4.4-2,4.4-4.4v-48.3c0-2.4-2-4.4-4.4-4.4h-71.7c-2.4,0-4.4,2-4.4,4.4 v48.2C-1020.9,330.1-1019,332-1016.6,332",
    className: "st2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path36_1_",
    d: "M-908.6,332.7h71.7c2.4,0,4.4-2,4.4-4.4V280c0-2.4-2-4.4-4.4-4.4h-71.7c-2.4,0-4.4,2-4.4,4.4 v48.2C-913,330.8-911,332.7-908.6,332.7",
    className: "st2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-728.6,274.7h-71.7c-2.4,0-4.4,2-4.4,4.4v48.2c0,2.4,1.9,4.4,4.3,4.4h71.7c2.4,0,4.4-2,4.4-4.4V279 C-724.2,276.7-726.2,274.7-728.6,274.7z M-735,292.8l-36.8,25.3l0,0l-6.9,4.7c-0.6,0.4-1.4,0.2-1.8-0.3l-4.7-6.8l-9.2-13.3 c-0.3-0.5-0.2-1.1,0.3-1.5l7.1-4.9c0.5-0.3,1.1-0.2,1.5,0.3l8.5,12.3l36-24.6c0.6-0.4,1.4-0.3,1.8,0.3l4.6,6.7 C-734.2,291.6-734.4,292.4-735,292.8z",
    className: "st3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path40_1_",
    d: "M-1016.6,411.7h71.7c2.4,0,4.4-2,4.4-4.4V359c0-2.4-2-4.4-4.4-4.4h-71.7c-2.4,0-4.4,2-4.4,4.4 v48.2C-1020.9,409.8-1019,411.7-1016.6,411.7",
    className: "st2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path42_1_",
    d: "M-908.6,411.7h71.7c2.4,0,4.4-2,4.4-4.4V359c0-2.4-2-4.4-4.4-4.4h-71.7c-2.4,0-4.4,2-4.4,4.4 v48.2C-913,409.8-911,411.7-908.6,411.7",
    className: "st2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path44_1_",
    d: "M-800.4,411.7h71.7c2.4,0,4.4-2,4.4-4.4V359c0-2.4-2-4.4-4.4-4.4h-71.7c-2.4,0-4.4,2-4.4,4.4 v48.2C-804.7,409.8-802.7,411.7-800.4,411.7",
    className: "st2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path46_1_",
    d: "M-965.8,98.8c11.4,0,20.7-9.3,20.7-20.7V38.8c0-5.7-2.3-10.9-6.1-14.6 c-3.7-3.7-8.9-6.1-14.6-6.1c-11.5,0-20.7,9.5-20.7,21v39C-986.5,89.6-977.2,98.8-965.8,98.8",
    className: "st3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path48_1_",
    d: "M-776.5,98.8c11.4,0,20.7-9.3,20.7-20.7V38.8c0-5.7-2.3-10.9-6.1-14.6 c-3.8-3.7-8.9-6.1-14.6-6.1c-11.4,0-20.7,9.3-20.7,20.7v39.3C-797.2,89.6-787.9,98.8-776.5,98.8",
    className: "st3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-778.6,322.8l-0.2,0.1c-0.5,0.3-1.1,0.2-1.5-0.3l-0.1-0.2C-780,323.1-779.2,323.2-778.6,322.8z",
    className: "st4"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-421.1,362.3v50.3h-169.1V128.8H-421v50.3h-116.7v76.4h97.4v47.8h-97.4v59H-421.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-271.3,416.4h-3.4l-134.8-284.5l2.1-3h56.5l79.2,181.9l77.9-181.9h55.4l1.5,2.6L-271.3,416.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.6,362.3v50.3h-169.2V128.8H56.6v50.3H-60v76.4h97.4v47.8H-60v59H56.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158,412.6h-52.6V124.9h3.4L302.4,305V128.8h52.7v287.5h-3.6l-193.6-180L158,412.6L158,412.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M536.2,412.6h-52.7v-232h-91.7v-51.8h236.1v51.8h-91.7L536.2,412.6L536.2,412.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M781.2,416.4c-41.5,0-75.8-13.8-103-41.4c-27.1-27.8-40.6-62.6-40.6-104.2c0-40.6,13.5-75.1,40.6-103.6 c27.3-28.2,62.2-42.3,104.5-42.3c42.1,0,76.4,14.1,103,42.3c26.6,27.7,39.9,62.1,39.9,103.2c0,40.7-13.5,75.3-40.6,103.8 C858.1,402.3,823.5,416.4,781.2,416.4z M872.1,270.8c0-27.5-8.5-49.9-25.5-67.3c-17-17.8-38.7-26.7-65-26.7 c-25.7,0-47.3,8.9-64.6,26.7c-17.3,17.6-25.9,40.1-25.9,67.3c0,26.5,8.6,48.7,25.9,66.7s38.8,27,64.6,27c25.6,0,47-9,64.3-27 C863.4,319.3,872.1,297,872.1,270.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1025.2,412.6h-52.6V128.8h100.2c29.2,0,53.4,8.8,72.4,26.3c19.2,17.6,28.7,42.5,28.7,74.7c0,33-10.5,59-31.4,77.9 c-20.5,18.5-45.7,27.8-75.4,27.8h-42v77.1H1025.2z M1064.4,176.8h-39.1v110.6h31.4c19.3,0,34.7-5.1,46.4-15.4s17.5-24.2,17.5-41.9 c0-17.4-5-30.6-15-39.7C1095.5,181.4,1081.8,176.8,1064.4,176.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1270,412.6h-52.7V128.8h52.7V412.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1441.9,124.9h3.4L1582.9,410l-2.1,2.6h-54.1l-20.2-46.1h-127l-20,46.1h-53.1l-1.9-2.6L1441.9,124.9z M1443,222 l-42.2,96.4h84.3L1443,222z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_1_"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "path26_3_",
    x1: 482.677,
    x2: 4.469,
    y1: -1552.089,
    y2: -972.442,
    gradientTransform: "matrix(1 0 0 -1 0 -1000)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#ff9a7b"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff6739"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "path26_2_",
    d: "M431.3,435.6c0,10.2-8.3,18.4-18.4,18.4H84.2c-10.2,0-18.4-8.3-18.4-18.4V152.7h365.5 L431.3,435.6L431.3,435.6z M425.8,57.8h-47.2v18.9c0,18.4-15,33.3-33.3,33.3c-18.4,0-33.3-15-33.3-33.3V57.8H188.2v18.9 c0,19.2-16.4,34.7-35.9,33.2c-17.4-1.3-30.8-16.1-30.8-33.6V57.8H74.3c-20.2,0-36.5,16.4-36.5,36.5v351.4 c0,20.1,16.4,36.5,36.5,36.5h351.4c20.1,0,36.5-16.3,36.5-36.5V94.4C462.2,74.2,445.9,57.8,425.8,57.8",
    className: "st6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "path28_3_",
    x1: 439.876,
    x2: -38.333,
    y1: -1587.4,
    y2: -1007.753,
    gradientTransform: "matrix(1 0 0 -1 0 -1000)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#ff9a7b"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff6739"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "path28_2_",
    d: "M103.7,252.4h72.3c2.4,0,4.4-2,4.4-4.4v-48.6c0-2.4-2-4.4-4.4-4.4h-72.3c-2.4,0-4.4,2-4.4,4.4 v48.6C99.3,250.5,101.2,252.4,103.7,252.4",
    className: "st7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "path30_3_",
    x1: 504.525,
    x2: 26.316,
    y1: -1534.065,
    y2: -954.418,
    gradientTransform: "matrix(1 0 0 -1 0 -1000)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#ff9a7b"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff6739"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "path30_2_",
    d: "M212.4,252.4h72.2c2.4,0,4.4-2,4.4-4.4v-48.6c0-2.4-2-4.4-4.4-4.4h-72.2c-2.4,0-4.4,2-4.4,4.4 v48.6C207.9,250.5,209.9,252.4,212.4,252.4",
    className: "st8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "path32_3_",
    x1: 568.977,
    x2: 90.769,
    y1: -1480.891,
    y2: -901.244,
    gradientTransform: "matrix(1 0 0 -1 0 -1000)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#ff9a7b"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff6739"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "path32_2_",
    d: "M321.2,253.1h72.2c2.4,0,4.4-2,4.4-4.4V200c0-2.4-2-4.4-4.4-4.4h-72.2c-2.4,0-4.4,2-4.4,4.4 v48.6C316.8,251.1,318.8,253.1,321.2,253.1",
    className: "st9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "path34_3_",
    x1: 400.637,
    x2: -77.571,
    y1: -1619.772,
    y2: -1040.125,
    gradientTransform: "matrix(1 0 0 -1 0 -1000)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#ff9a7b"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff6739"
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "path34_2_",
    d: "M103.7,332.2h72.2c2.4,0,4.4-2,4.4-4.4v-48.5c0-2.4-2-4.4-4.4-4.4h-72.2c-2.4,0-4.4,2-4.4,4.4 v48.5C99.3,330.4,101.2,332.2,103.7,332.2",
    className: "st10"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "path36_3_",
    x1: 464.97,
    x2: -13.239,
    y1: -1566.697,
    y2: -987.05,
    gradientTransform: "matrix(1 0 0 -1 0 -1000)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#ff9a7b"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff6739"
    }
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "path36_2_",
    d: "M212.4,333h72.2c2.4,0,4.4-2,4.4-4.4v-48.6c0-2.4-2-4.4-4.4-4.4h-72.2c-2.4,0-4.4,2-4.4,4.4 v48.5C207.9,331,209.9,333,212.4,333",
    className: "st11"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    x1: 530.248,
    x2: 52.039,
    y1: -1512.843,
    y2: -933.196,
    gradientTransform: "matrix(1 0 0 -1 0 -1000)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#ff9a7b"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff6739"
    }
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M393.5,274.6h-72.2c-2.4,0-4.4,2-4.4,4.4v48.5c0,2.4,1.9,4.4,4.3,4.4h72.2c2.4,0,4.4-2,4.4-4.4v-48.6 C397.8,276.6,395.8,274.6,393.5,274.6z M387.1,292.7l-37,25.5l0,0l-6.9,4.7c-0.6,0.4-1.4,0.2-1.8-0.3l-4.7-6.8l-9.3-13.4 c-0.3-0.5-0.2-1.1,0.3-1.5l7.1-4.9c0.5-0.3,1.1-0.2,1.5,0.3l8.6,12.4l36.2-24.8c0.6-0.4,1.4-0.3,1.8,0.3l4.6,6.7 C387.8,291.6,387.7,292.3,387.1,292.7z",
    className: "st12"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "path40_3_",
    x1: 361.266,
    x2: -116.943,
    y1: -1652.253,
    y2: -1072.607,
    gradientTransform: "matrix(1 0 0 -1 0 -1000)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#ff9a7b"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff6739"
    }
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "path40_2_",
    d: "M103.7,412.5h72.2c2.4,0,4.4-2,4.4-4.4v-48.6c0-2.4-2-4.4-4.4-4.4h-72.2c-2.4,0-4.4,2-4.4,4.4 v48.5C99.3,410.5,101.2,412.5,103.7,412.5",
    className: "st13"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "path42_3_",
    x1: 425.944,
    x2: -52.264,
    y1: -1598.894,
    y2: -1019.247,
    gradientTransform: "matrix(1 0 0 -1 0 -1000)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#ff9a7b"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff6739"
    }
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "path42_2_",
    d: "M212.4,412.5h72.2c2.4,0,4.4-2,4.4-4.4v-48.6c0-2.4-2-4.4-4.4-4.4h-72.2c-2.4,0-4.4,2-4.4,4.4 v48.5C207.9,410.5,209.9,412.5,212.4,412.5",
    className: "st14"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "path44_3_",
    x1: 490.733,
    x2: 12.524,
    y1: -1545.443,
    y2: -965.796,
    gradientTransform: "matrix(1 0 0 -1 0 -1000)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#ff9a7b"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff6739"
    }
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "path44_2_",
    d: "M321.2,412.5h72.2c2.4,0,4.4-2,4.4-4.4v-48.6c0-2.4-2-4.4-4.4-4.4h-72.2c-2.4,0-4.4,2-4.4,4.4 v48.5C316.8,410.5,318.8,412.5,321.2,412.5",
    className: "st15"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "path46_3_",
    x1: 530.608,
    x2: 52.399,
    y1: -1512.546,
    y2: -932.899,
    gradientTransform: "matrix(1 0 0 -1 0 -1000)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#ff9a7b"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff6739"
    }
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "path46_2_",
    d: "M154.7,97.5c11.5,0,20.8-9.4,20.8-20.8V37.1c0-5.7-2.3-11-6.1-14.7c-3.7-3.7-9-6.1-14.7-6.1 c-11.6,0-20.8,9.6-20.8,21.1v39.2C133.9,88.2,143.3,97.5,154.7,97.5",
    className: "st16"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "path48_3_",
    x1: 643.995,
    x2: 165.787,
    y1: -1419.002,
    y2: -839.355,
    gradientTransform: "matrix(1 0 0 -1 0 -1000)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#ff9a7b"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff6739"
    }
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "path48_2_",
    d: "M345.3,97.5c11.5,0,20.8-9.4,20.8-20.8V37.1c0-5.7-2.3-11-6.1-14.7c-3.8-3.7-9-6.1-14.7-6.1 c-11.5,0-20.8,9.4-20.8,20.8v39.5C324.4,88.2,333.8,97.5,345.3,97.5",
    className: "st17"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    x1: 511.718,
    x2: 33.509,
    y1: -1528.13,
    y2: -948.484,
    gradientTransform: "matrix(1 0 0 -1 0 -1000)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#ff9a7b"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff6739"
    }
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M343.2,322.9L343,323c-0.5,0.3-1.1,0.2-1.5-0.3l-0.1-0.2C341.8,323.3,342.5,323.4,343.2,322.9z",
    className: "st18"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMainIcon);
export default __webpack_public_path__ + "static/media/main-icon.5d3191977b4f128623ee8bcbfc785205.svg";
export { ForwardRef as ReactComponent };